import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CarOutlinedSvg from "@ant-design/icons-svg/es/asn/CarOutlined";
import AntdIcon from '../components/AntdIcon';
var CarOutlined = function CarOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: CarOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(CarOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'CarOutlined';
}
export default RefIcon;